import { render, staticRenderFns } from "./form-feedback.vue?vue&type=template&id=1d1d9c90&"
import script from "./form-feedback.vue?vue&type=script&lang=js&"
export * from "./form-feedback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports